document.addEventListener("DOMContentLoaded", () => {
    const inputSearchIcon = document.getElementById("search-icon-all");
    const inputSearchBteIcon = document.getElementById("search-icon-bte");

    /**
     * List Of All Trilogy Icons
     */
    const iconsAllList = document.querySelectorAll(
        "#icons-all .static-icon-snippet .tag"
    );

    /**
     * List Of All BTE Trilogy Icons
     */
    const iconsBTEList = document.querySelectorAll(
        "#icons-bte .static-icon-snippet .tag"
    );

    if (inputSearchIcon !== null) {
        inputSearchIcon.addEventListener("input", (e) => {
            let inputText = e.target.value;
            let pat = new RegExp(inputText, "i");

            for (let i = 0; i < iconsAllList.length; i++) {
                let item = iconsAllList[i];
                if (pat.test(item.innerText)) {
                    item.closest(".static-icon-snippet").classList.remove(
                        "is-hidden"
                    );
                } else {
                    item.closest(".static-icon-snippet").classList.add(
                        "is-hidden"
                    );
                }
            }
        });
    }

    if (inputSearchBteIcon !== null) {
        inputSearchBteIcon.addEventListener("input", (e) => {
            let inputText = e.target.value;
            let pat = new RegExp(inputText, "i");

            for (let i = 0; i < iconsBTEList.length; i++) {
                let item = iconsBTEList[i];
                if (pat.test(item.innerText)) {
                    item.closest(".static-icon-snippet").classList.remove(
                        "is-hidden"
                    );
                } else {
                    item.closest(".static-icon-snippet").classList.add(
                        "is-hidden"
                    );
                }
            }
        });
    }
});
